module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.e452a28c.jpeg";